module.exports = __webpack_public_path__ + "9f8a9456bc0ba4b55cf890c2010c459d.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/iconos/cotizar.png
// module id = 2156
// module chunks = 0